module.exports = __webpack_public_path__ + "static/media/icon-toggle-range-minus.2efe1f1e.svg";